// Core
import { Box, Text, useColorModeValue } from '@chakra-ui/react';

// Assets
import { ReactComponent as CloseIcon } from 'assets/svg/close.svg';

export default function NotifySuccess({text, setNotify}) {
  const bgColor = useColorModeValue('rgba(255, 247, 217, 0.50)', 'rgba(24, 23, 16, 0.50)');

  return (
    <>
    	<Box
          borderRadius="0 0 16px 16px"
          background="#22973F"
          boxShadow="0 1px 3px 0 rgba(0, 0, 0, 0.10)"
          textAlign="center"
          position="fixed"
          top="0"
          left="0"
          w="100%"
          p={{ base: '12px 10% 10px 10%', sm: '12px 0 14px 0',  md: '19px 0 18px 0'}}
          zIndex="999"
          >
          <Text 
            variant="title-md"
            fontWeight="700"
            textTransform="uppercase"
            fontSize={{base: '10px', sm: '12px', md: 'initial'}}
            >{text}</Text>

          <CloseIcon 
            onClick={() => setNotify()}
            style={{
              cursor: 'pointer',
              position: 'absolute',
              right: '12px',
              top: '5px'
            }} />
          </Box>
    </>
  );
}